import type { ClientConfig } from './types';
import { client99h } from './99h';
import { clientDemo } from './demo';
import { clientDf } from './df';

/**
 * Every client the build knows about, keyed by the value of `VITE_CLIENT`.
 *
 * Imported by `vite.config.ts` as well as the app, so keep this file free of
 * React and browser globals.
 */
export const CLIENTS = {
  '99h': client99h,
  demo: clientDemo,
  df: clientDf,
} satisfies Record<string, ClientConfig>;

export type ClientId = keyof typeof CLIENTS;

/** The client used when `VITE_CLIENT` is unset or unknown. */
export const DEFAULT_CLIENT_ID: ClientId = '99h';

/**
 * Resolves a client id to its config, falling back to the default.
 *
 * An unknown id is a misconfigured deployment, not a reason to crash — it
 * warns and serves the default rather than shipping a blank app.
 */
export function resolveClient(id: string | undefined): ClientConfig {
  if (id && id in CLIENTS) return CLIENTS[id as ClientId];
  if (id) console.warn(`[clients] unknown VITE_CLIENT "${id}" — using "${DEFAULT_CLIENT_ID}"`);
  return CLIENTS[DEFAULT_CLIENT_ID];
}
